module.exports = __webpack_public_path__ + "static/tabLeaders-032e1cc2857acde5b363f7f23ccec0f1.png";